import { render, staticRenderFns } from "./DataTableSimple.vue?vue&type=template&id=40992786&scoped=true&"
import script from "./DataTableSimple.vue?vue&type=script&lang=js&"
export * from "./DataTableSimple.vue?vue&type=script&lang=js&"
import style0 from "./DataTableSimple.vue?vue&type=style&index=0&id=40992786&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40992786",
  null
  
)

export default component.exports